import React, { useContext, useEffect, useState } from 'react';
import CallTableViewModel from '../../../ViewModels/CallTableViewModel';
import { APIContext } from '../../../Contexts/APIContext';
import CXAIFiltersViewModel from './ViewModels/CXAIFiltersViewModel';
import { useSnackbar } from 'notistack';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

interface IFiltersDialogProps {
    open: boolean
    setOpen: (value: boolean) => void
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function CXAIFiltersDialog(props: IFiltersDialogProps) {
    const { get } = useContext(APIContext);
    const [channelOptions, setChannelOptions] = useState<string[]>([]);
    const [questionOptions, setQuestionOptions] = useState<string[]>([]);
    //const [categoryOptions, setCategoryOptions] = useState<string[]>([]);
    const [cxAIFilter, setCXAIFilter] = useState<CXAIFiltersViewModel>(props.callTableViewModel.filters.cxaiFilters);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (props.open) {
            setCXAIFilter(props.callTableViewModel.filters.cxaiFilters);
        }
    }, [props.open])

    useEffect(() => {
        if (cxAIFilter.channel !== '') getQuestionOptions(); //getCategoryOptions();
    }, [cxAIFilter.channel]);

    // useEffect(() => {
    //     if (cxAIFilter.channel !== '' && cxAIFilter.category !== '') getQuestionOptions();
    // }, [cxAIFilter.category]);

    // const getCategoryOptions = () => {
    //     get('AIAnalysis', `GetCXAICategoryOptions?channel=` + cxAIFilter.channel + '&client=' + props.callTableViewModel.filters.client, (data) => {
    //         setCategoryOptions(data)
    //     });
    // }

    //#region database calls
    useEffect(() => {
        get('AIAnalysis', `GetCXAIChannelOptions?client=${props.callTableViewModel.filters.client}`, (data) => setChannelOptions(data));
    }, [props.callTableViewModel.filters.client]);

    const getQuestionOptions = () => {
        get('AIAnalysis', `GetCXAIQuestionOptions?channel=` + cxAIFilter.channel + '&client=' + props.callTableViewModel.filters.client, (data) => { //+ '&category=' + cxAIFilter.category
            setQuestionOptions(data)
        });
    }
    //#endregion

    const HandleSelect = (key: string, value: string) => {
        setCXAIFilter({
            ...cxAIFilter,
            [key]: value
        });
    };

    const HandleSelectChannel = (value: string) => {
        setCXAIFilter({
            ...cxAIFilter,
            channel: value,
            question: "",
            //category: "",
            answer: ""
        });
    }
    // const HandleSelectCategory = (value: string) => {
    //     setCXAIFilter({
    //         ...cxAIFilter,
    //         //category: value,
    //         question: "",
    //         answer: ""
    //     });
    // }
    const HandleSelectAnswer = (value: string) => {
        setCXAIFilter({
            ...cxAIFilter,
            answer: value
        });
    }

    const Confirm = () => {
        if (cxAIFilter.channel !== '' && cxAIFilter.question !== '' && cxAIFilter.answer !== '') { //cxAIFilter.category !== '' && 
            const newCallTableViewModel = { ...props.callTableViewModel };

            newCallTableViewModel.filters.cxaiFilters = cxAIFilter;

            props.setCallTableViewModel({
                ...newCallTableViewModel
            })
            props.setOpen(false);
        } else {
            enqueueSnackbar("All values must be selected to confirm", { variant: 'warning' });
        }
    }

    return (
        <Dialog onClose={() => props.setOpen(false)} open={props.open} fullWidth maxWidth="sm">
            <DialogTitle>CX-AI</DialogTitle>
            <DialogContent>
                {channelOptions.length > 0 ?
                    <Grid container style={{ width: '100%' }}>
                        <Grid size={12}>
                            <InputLabel>Channel</InputLabel>
                            <TextField
                                select
                                name="channel"
                                value={cxAIFilter.channel}
                                onChange={(e) => HandleSelectChannel(e.target.value)}
                                fullWidth
                            >
                                {channelOptions.length > 0 && channelOptions.map((channel: string) => {
                                    return (<MenuItem key={channel} value={channel}>{channel}</MenuItem>);
                                })}
                            </TextField>
                        </Grid>
                        {
                        /*
                            cxAIFilter.channel !== '' &&
                            <Grid size={12}>
                                <InputLabel>Category</InputLabel>
                                <TextField
                                    select
                                    name="category"
                                    value={cxAIFilter.category}
                                    onChange={(e) => HandleSelectCategory(e.target.value)}
                                    fullWidth
                                    disabled={cxAIFilter.channel === ''}
                                >
                                    {categoryOptions.length > 0 && categoryOptions.map((category: DropdownViewModel) => {
                                        return (<MenuItem key={category.id} value={category.label}>{category.label}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                        */
                        }
                        {cxAIFilter.channel !== '' && /* cxAIFilter.category !== '' && */
                            <Grid size={12}>
                                <InputLabel>Question</InputLabel>
                                <TextField
                                    select
                                    name="question"
                                    value={cxAIFilter.question}
                                    onChange={(e) => HandleSelect(e.target.name, e.target.value)}
                                    fullWidth
                                    disabled={cxAIFilter.channel === '' /* || cxAIFilter.category === '' */}
                                >
                                    {questionOptions.length > 0 && questionOptions.map((question: string) => {
                                        return (<MenuItem key={question} value={question}>{question}</MenuItem>);
                                    })}
                                </TextField>
                            </Grid>
                        }
                        {cxAIFilter.channel !== '' && cxAIFilter.question !== '' && /* cxAIFilter.category !== '' &&*/
                            <Grid size={12}>
                                <InputLabel>Answer</InputLabel>
                                <TextField
                                    select
                                    name="answer"
                                    value={cxAIFilter.answer}
                                    onChange={(e) => HandleSelectAnswer(e.target.value)}
                                    fullWidth
                                    disabled={cxAIFilter.channel === '' || cxAIFilter.question === '' /* || cxAIFilter.category === '' */}
                                >
                                    <MenuItem key={0} value="Yes">Yes</MenuItem>
                                    <MenuItem key={1} value="No">No</MenuItem>
                                    <MenuItem key={2} value="N/A">N/A</MenuItem>
                                </TextField>
                            </Grid>
                        }
                    </Grid>
                    :
                    <p>This AI Filter Is Not Used By This Client</p>
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.setOpen(false)} color="primary">Cancel</Button>
                {channelOptions.length > 0 &&
                    <Button onClick={Confirm} color="primary">Confirm</Button>
                }
            </DialogActions>
        </Dialog>
    )
}